import PropTypes from 'prop-types';
import { useEffect, useId, useState } from 'react';
import Filters from 'src/components/form/filters/filters';
import { searchInputValidationSchema } from 'src/components/form/search/filters-form/helper';
import SearchInput from 'src/components/form/search/filters-form/search-input';
import SingleSelectInput from 'src/components/form/select-input/select-input';
import API from '../api/api';
import css from './form.module.scss';
import { CourseFilters } from '../types';

SearchForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired
};

interface CourseSearchFormProps {
  onSubmit: (data: Partial<CourseFilters>) => void;
  initialValues: CourseFilters;
}

export default function SearchForm({ onSubmit, initialValues }: Readonly<CourseSearchFormProps>) {
  const inputId = useId();
  const [vendors, setVendors] = useState<string[]>([]);

  useEffect(() => {
    API.getVendors().then(setVendors);
  }, []);

  return (
    <Filters
      initialFilters={initialValues}
      onSearch={onSubmit}
      validationSchema={searchInputValidationSchema('search')}
      fieldsToSubmitOnChange={['search', 'vendor']}
      render={({ errors, control, registerAndClearOnChange, _ }) => (
        <div className={css.educationInputGroup}>
          <SearchInput
            id={inputId}
            name='search'
            placeholder='Шукати курс'
            inputProps={registerAndClearOnChange('search')}
            error={errors?.search?.message}
          />
          <SingleSelectInput
            name='vendor'
            control={control}
            options={[{ value: '', label: 'Всі надавачі курсів' }, ...vendors.map((v) => ({ value: v, label: v }))]}
          />
        </div>
      )}
    />
  );
}
